<!-- 名录学者列表页 -->
<template>
  <div class="box safe-distance-top-header">
    <Header :pageTitle="''"></Header>
    <BjItem
      class="bj-list-item"
      v-for="item in list"
      :key="item.id"
      :headerPhoto="item.headPhoto"
      :name="item.name"
      :unit="item.unit"
      :research="item.researchDirection"
      @click.native="toDetail(item.id)"
    />
  </div>
</template>

<script>
import Header from "@/views/mobileView/detail/components/detailHeader.vue";
import BjItem from "@/views/mobileView/components/listItem/bjItem.vue";
export default {
  components: {
    Header,
    BjItem,
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.$apis.hundredServe
      .nfdetail({ orgId: this.$route.query.orgId })
      .then((result) => {
        this.list = [...result.orgUser];
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    // 点击进入详情页
    toDetail(id) {
      let out = this.$route.query.out;
      this.$router.push({
        path: "/appusesbaijia",
        query: {
          item: 0,
          id,
          out,
        },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.box {
  padding: 56px 12px 12px;
  min-height: 100vh;
  background-color: #f5f5f5;
  .bj-list-item {
    margin: 0 0 12px;
    padding: 15px 12px;
    width: 100%;
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;
  }
}
</style>